import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import { type RuleBasedAutomation } from '../models';

export function ruleBasedAutomationTooltipContent(
  rule: RuleBasedAutomation['rule'],
  t: TGlobalFunctionTyped,
) {
  const key = rule.name
    ? `expenseInbox.expenseEditor.prefilledByAdvancedNamedRule`
    : `expenseInbox.expenseEditor.prefilledByAdvancedUnnamedRule`;

  const conditionKey =
    rule.conditions.length > 1
      ? `expenseInbox.expenseEditor.multiCondition`
      : `expenseInbox.expenseEditor.singleCondition`;

  return t(key, {
    singleOrMultipleCondition: t(conditionKey),
    ruleName: rule.name,
  });
}
